import axios from 'axios';
import { getAPIHost, getAppCountry, getAppLanguage, getAppToken, getLoginToken } from '../../ui/utils/helper';
import { isTokenValid, doLogout } from '../../ui/utils/auth';

axios.interceptors.request.use(request => {
  request.headers['Content-Type'] = 'application/json';

  // Remember to update any new token to fetchUtils too
  const loginToken = getLoginToken();
  const appToken = getAppToken();
  const appCountry = getAppCountry();
  const appLangauge = getAppLanguage();

  if (loginToken) {
    request.headers['x-app-token'] = loginToken;
  }
  if (appToken) {
    if (isTokenValid(appToken)) {
      // with valid token time
      request.headers['x-access-token'] = appToken;
    } else {
      doLogout();
      window?.location?.reload();
      throw new axios.Cancel();
    }
  }
  if (appCountry) {
    request.headers['x-app-country'] = appCountry;
  }
  if (appLangauge) {
    request.headers['x-app-language'] = appLangauge;
  }

  // passing dummy value as x-app-token (to be use for requestToken API)
  if (!appToken && !loginToken) {
    request.headers['x-app-token'] = btoa(process.env.REACT_APP_ENCRYPTION_KEY || 'myportal');
  }
  return request;
}, undefined);

axios.interceptors.response.use(
  response => {
    if (response.status === 204) {
      // patch the message for 204
      response.data = {
        returnMessage: response.headers['return-message'],
      };
    }
    return response;
  },
  failedResponse => {
    if (failedResponse.response?.status === 401) {
      throw new axios.Cancel();
    }

    return Promise.reject(failedResponse);
  },
);

// eslint-disable-next-line import/no-anonymous-default-export
const baseUrl = getAPIHost() ?? '';
axios.defaults.baseURL = baseUrl.indexOf('localhost') > -1 ? baseUrl : `${baseUrl}/`;
